import request from '@/utils/request'


// 查询医院华歧系数变动记录列表
export function listScoreRecord(query) {
  return request({
    url: '/hospital/scoreRecord/list',
    method: 'get',
    params: query
  })
}

// 查询医院华歧系数变动记录分页
export function pageScoreRecord(query) {
  return request({
    url: '/hospital/scoreRecord/page',
    method: 'get',
    params: query
  })
}

// 查询医院华歧系数变动记录详细
export function getScoreRecord(data) {
  return request({
    url: '/hospital/scoreRecord/detail',
    method: 'get',
    params: data
  })
}

// 新增医院华歧系数变动记录
export function addScoreRecord(data) {
  return request({
    url: '/hospital/scoreRecord/add',
    method: 'post',
    data: data
  })
}

// 修改医院华歧系数变动记录
export function updateScoreRecord(data) {
  return request({
    url: '/hospital/scoreRecord/edit',
    method: 'post',
    data: data
  })
}

// 删除医院华歧系数变动记录
export function delScoreRecord(data) {
  return request({
    url: '/hospital/scoreRecord/delete',
    method: 'post',
    data: data
  })
}
